// @flow
import CustomError from 'lib/CustomError';

export default async function checkResponseStatus(
  res: Response
): Promise<Response> {
  if (res.status >= 200 && res.status < 300) {
    return res;
  }
  const e = await res.json();
  throw new CustomError(JSON.stringify(e));
}
